import { createStyles, makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) =>
  createStyles({
    input: { paddingTop: 0, paddingBottom: 0, minHeight: theme.spacing(4.75) },
  }),
);
